import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost, type PostValue } from './client'

/**
 * Settings → Easeedesk → Auto-assign settings.
 *
 * Perechile vechi: `auto_assign`, `save_auto_assign`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface AutoAssignTeam {
  group_id: number
  group_name: string
  /** Cati oameni are echipa, si cati au bifat "Auto assign" pe cont. */
  members: number
  opted_in: number
  enabled: number
  strategy: number
  only_online: number
  online_minutes: number
  respect_work_hours: number
  require_optin: number
  prefer_office_responsible: number
  updated_at: string | null
}

export interface AutoAssignPage {
  title: string
  moduleUrl: string
  strategies: { value: number; label: string }[]
  /** Citirea si scrierea au drepturi diferite: se poate vedea fara sa se poata schimba. */
  can_edit: boolean
  teams: AutoAssignTeam[]
}

const BASE = '/settings/easeedesk/auto_assign'

export function autoAssignPageQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'auto_assign'],
    queryFn: () => apiGet<AutoAssignPage>(BASE),
  })
}

/** Campurile pe care le scrie o echipa. Aceleasi nume ca in tabela. */
export type AutoAssignFields = Pick<
  AutoAssignTeam,
  | 'enabled'
  | 'strategy'
  | 'only_online'
  | 'online_minutes'
  | 'respect_work_hours'
  | 'require_optin'
  | 'prefer_office_responsible'
>

/**
 * Toate echipele deodata, ca in ecranul vechi: un buton pentru tot.
 *
 * Corpul e chiar `teams[<group_id>][camp]`, forma pe care o trimitea
 * formularul din portal - asa cele doua capete raman de citit unul langa
 * altul. Cheile sunt numere de grup, nu indici, deci se scriu de mana.
 */
export function saveAutoAssign(teams: Record<number, AutoAssignFields>) {
  const fields: Record<string, PostValue> = {}
  for (const [groupId, one] of Object.entries(teams)) {
    for (const [name, value] of Object.entries(one)) {
      fields[`teams[${groupId}][${name}]`] = value
    }
  }

  return apiPost<{ ok?: boolean; saved?: number }>(BASE, fields)
}
